import { render, staticRenderFns } from "./CourseViewCourseInfoCard.vue?vue&type=template&id=f245a810&"
import script from "./CourseViewCourseInfoCard.vue?vue&type=script&lang=js&"
export * from "./CourseViewCourseInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports